import { render, staticRenderFns } from "./orders-list.vue?vue&type=template&id=c0bd3d26&"
import script from "./orders-list.vue?vue&type=script&lang=js&"
export * from "./orders-list.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./orders-list.vue?vue&type=style&index=1&id=c0bd3d26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports